import { createActions } from 'redux-actions';

const {
  autoSearchByNum,
  autoSearchByNumSuccess,
  autoSearchByNumError,
  autoSearchByNumReset,
} = createActions(
  'AUTO_SEARCH_BY_NUM',
  'AUTO_SEARCH_BY_NUM_SUCCESS',
  'AUTO_SEARCH_BY_NUM_ERROR',
  'AUTO_SEARCH_BY_NUM_RESET'
);

export {
  autoSearchByNum,
  autoSearchByNumSuccess,
  autoSearchByNumError,
  autoSearchByNumReset,
};
